import * as React from 'react';

var _path, _path2, _rect;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgWalletSolid = function SvgWalletSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M2.118 12.235V6.33a.8.8 0 0 1 .8-.8h9.788c.312 0 .611.116.832.322s.344.485.344.776a.573.573 0 0 1-.572.573h-1.39c-1.06 0-1.92.86-1.92 1.92v.16c0 1.06.86 1.92 1.92 1.92h1.162a.8.8 0 0 1 .8.8v.235c0 .292-.124.57-.344.777a1.22 1.22 0 0 1-.832.321H3.294a1.22 1.22 0 0 1-.832-.321 1.06 1.06 0 0 1-.344-.777"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M10.8 9.2A1.2 1.2 0 0 1 12 8h2.6a1 1 0 0 1 1 1v.4a1 1 0 0 1-1 1H12a1.2 1.2 0 0 1-1.2-1.2"
    })), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        width: 9.6,
        height: 1.6,
        x: 2,
        y: 3.2,
        fill: "currentColor",
        rx: 0.8
    })));
};

export { SvgWalletSolid as ReactComponent };
//# sourceMappingURL=WalletSolid.svg.es.js.map
